import { gql } from "@apollo/client"
import type { Hiring, Maybe } from "@oysterhr/schema"

export const ADVISOR_SHARED_CONTEXT_FRAGMENT = gql`
  fragment AdvisorSharedContextFragment on Employment {
    id
    hiring {
      id
      agreements {
        isAutomated
      }
    }
  }
`

export type AdvisorSharedContextFragment = {
  id: string
  hiring?: Maybe<
    Pick<Hiring, "id"> & {
      agreements: Pick<Hiring["agreements"][0], "isAutomated">[]
    }
  >
}
